import { Icon } from '../UI';
import React from 'react';

interface WindowWidgetProps {
  title: string;
  actions?: JSX.Element[];
  open?: boolean;
  className?: string;
  id?: string;
  windowed?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onScroll?: (event: React.UIEvent<HTMLElement>) => void;
  children: React.ReactNode;
}

const WindowWidget = React.forwardRef<HTMLElement, WindowWidgetProps>(
  (
    {
      title,
      actions,
      children,
      className = '',
      id,
      windowed,
      onChange,
      onScroll,
    },
    ref
  ) => {
    return (
      <aside
        ref={ref}
        className={`bg-white border-1 border-grey-10 dark:text-white dark:border-grey-80 right-0 w-88 z-20 max-h-full-18 flex flex-col ${className} ${
          windowed ? 'w-full static h-screen' : 'fixed h-full bottom-0'
        }`}
        id={id}
      >
        <div className={'flex flex-col h-full bg-white dark:bg-grey-90'}>
          {!windowed && (
            <div className="flex items-center justify-between  border-b border-grey-10 dark:border-grey-80 px-4 py-3">
              <h2 className="uppercase text-black font-semibold dark:text-white font-sans select-none">
                {title}
              </h2>
              <div className="flex gap-5 h-3 items-center">{actions}</div>
            </div>
          )}
          {/* Search */}
          {onChange && (
            <div className="flex items-center px-4 py-5 border-b border-grey-10 dark:border-grey-80">
              <Icon
                className=" h-4 text-lg mt-1"
                color="black"
                svgName={'search'}
              />
              <input
                type="text"
                placeholder="Search"
                className="pl-1 w-3/4 text-black flex-grow-1 pr-4 dark:bg-grey-90 dark:text-white"
                onChange={onChange}
              />
            </div>
          )}
          <div
            onScroll={onScroll}
            className="flex-grow-1 flex flex-col h-full overflow-hidden"
          >
            {children}
          </div>
        </div>
      </aside>
    );
  }
);
export default WindowWidget;
